import { ref, onMounted } from "vue";
import apiCall from "@/utils/api";

export function useClientDashboardCounts() {
  const numberOfBuildings = ref(null);
  const numberOfSchemePlans = ref(null);
  const countsLoading = ref(true);

  async function fetchCounts() {
    countsLoading.value = true;
    try {
      const [buildingsRes, schemePlansRes] = await Promise.all([
        apiCall({
          url: "/api/client/building?type=clientsApplications&page=1",
          method: "GET",
        }),
        apiCall({
          url: "/api/client/scheme-plan-property?page=1",
          method: "GET",
        }),
      ]);
      numberOfBuildings.value = buildingsRes.total ?? 0;
      numberOfSchemePlans.value = schemePlansRes.total ?? 0;
    } catch {
      numberOfBuildings.value = 0;
      numberOfSchemePlans.value = 0;
    } finally {
      countsLoading.value = false;
    }
  }

  onMounted(fetchCounts);

  return {
    numberOfBuildings,
    numberOfSchemePlans,
    countsLoading,
  };
}
